import { render, staticRenderFns } from "./starStandard.vue?vue&type=template&id=167a522d"
import script from "./starStandard.vue?vue&type=script&lang=js"
export * from "./starStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports